import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService, CampaignConfig } from '../../services/campaign.service';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Component({
  selector: 'app-campaign-landing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './campaign-landing.component.html',
  styleUrl: './campaign-landing.component.css'
})
export class CampaignLandingComponent implements OnInit {
  campaign: CampaignConfig | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignService: CampaignService,
    private analytics: Analytics
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('slug');
      if (slug) {
        this.campaignService.getCampaignBySlug(slug).subscribe(campaignData => {
          this.campaign = campaignData;
          if (this.campaign) {
            // Track campaign page visit
            logEvent(this.analytics, 'campaign_page_view', {
              campaign_slug: this.campaign.slug,
              campaign_title: this.campaign.title
            });
          }
        });
      }
    });
  }

  onResourceClick(resource: any) {
    if (!this.campaign) return;
    
    // Track resource click
    logEvent(this.analytics, 'campaign_resource_click', {
      campaign_slug: this.campaign.slug,
      resource_title: resource.title,
      resource_category: resource.category
    });

    // Navigate to the dedicated Campaign Details page
    // We pass the resource via route state so the details page can pre-render it beautifully
    this.router.navigate(['/campaign/details', resource.nid], { state: { item: resource } });
  }
}
